export default {
feedback: {
  title: "Feedback",
  placeholder: "Leave a note ({contentLen}/1000 characters)",
  error: "This is an error message",
  uploadLimit: "Upload image limit and video limit",
  send: "Send",
  tipTitle: "Help us improve your experience",
  desc1: "You can submit any questions to us, and if your questions are accepted, you will receive a surprise gift package.",
  desc2: "If it is inconvenient to submit questions through the website, you can also send them to our email."
}
};
